import { Component, Inject, InjectionToken, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CONTROL } from 'src/app/shared/injectors/control-injector';

@Component({
  selector: 'app-headline-input',
  templateUrl: './headline-input.component.html',
  styleUrls: ['./headline-input.component.scss'],
})
export class HeadlineInputComponent {
  @Input() control!: FormControl;
  // NOTE: The whole field, never a substring of it — one rule with the body (ADR-0007).
  @Input() isFlashed = false;
  constructor(@Inject(CONTROL) controlInjected: FormControl) {
    this.control = this.control || controlInjected;
  }
}
